import React, { useState } from "react";
import Card, { CardBody, CardTitle } from "../ui/Card";

const Accordion = ({ title, children, defaultOpen }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen || false);

  return (
    <Card>
      <div
        className="flex items-center justify-between w-full p-[13px] cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <CardTitle>{title}</CardTitle>
        <svg
          className={`w-6 h-6 transform transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      <div className={`transition-all duration-300 ease-in-out overflow-hidden`}>
        {isOpen && <CardBody>{children}</CardBody>}
      </div>
    </Card>
  );
};

export default Accordion;
